var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:'flag-icon flag-icon-' + _vm.cc,attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }